export default "__VITE_ASSET__CoOgLIoF__"